import React, { useEffect } from "react";
import Modal from "react-modal";
import closeIcon from "../../../assets/img/cross-icon.svg";
import { customModalStyles } from "../../utils/styles";
import { hideGreyBackground, showGreyBackground } from "../../utils/windows";

const modalStyles = customModalStyles(20);
modalStyles.content.padding = 0;
modalStyles.overlay = {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  zIndex: 10000,
  overflowY: "auto",
  overflowX: "hidden"
};

const DetalleCierreMensualMobileModal = ({
  isOpen,
  closeModal,
  title,
  subtitle,
  rows = [],
  isTotal = false
}) => {
  useEffect(() => {
    if (!isOpen) return;

    showGreyBackground();
    return () => hideGreyBackground();
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={modalStyles}
      className="responsive-modal cierre-mensual-detalle-modal"
      overlayClassName="ReactModal__Overlay cierre-mensual-responsive-modal-overlay"
    >
      <div className="cierre-mensual-detalle-modal-container">
        <div className="cierre-mensual-detalle-modal-header">
          <div>
            <div className="cierre-mensual-detalle-modal-title">{title}</div>
            {subtitle && <div className="cierre-mensual-detalle-modal-subtitle">{subtitle}</div>}
          </div>
          <button className="cierre-mensual-detalle-modal-close" onClick={closeModal}>
            <img src={closeIcon} alt="Cerrar" />
          </button>
        </div>

        <div className="cierre-mensual-detalle-modal-separator" />

        <table className="cierre-mensual-detalle-modal-table">
          <thead>
            <tr>
              <th>Detalle</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr className="separator-table-row">
              <th colSpan="100%" />
            </tr>
            {rows.map((row, index) => (
              <React.Fragment key={`detalle-cierre-mensual-${row.isPill}-${row.value}`}>
                <tr>
                  <td>{row.label}</td>
                  <td className="align-right">
                    {isTotal || row.isPill ?
                      <span className="cierre-mensual-detalle-modal-pill">{row.value}</span>
                      :
                      row.value
                    }
                  </td>
                </tr>
                {index < rows.length - 1 && (
                  <tr className="separator-table-row">
                    <th colSpan="100%" />
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>

        <button className="cierre-mensual-detalle-modal-button" onClick={closeModal}>
          Cerrar
        </button>
      </div>
    </Modal>
  );
};

export default DetalleCierreMensualMobileModal;
